import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomTabsComponent } from './custom-tabs.component';
import { Router, RouterLink } from '@angular/router';



@NgModule({
  declarations: [
    CustomTabsComponent
  ],
  imports: [
    CommonModule,
    RouterLink,

  ],
  exports: [
    CustomTabsComponent
  ]
})
export class CustomTabsModule { }
